var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"KnTextRow contentModule hSpace hSpace--formRow",class:_vm.elmClasses,attrs:{"name":"KnTextRow"}},[_c('div',{staticClass:"KnTextRow__inner contentModule__inner"},[_c('div',{staticClass:"KnTextRow__text"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }